import styles from '../delivery.module.scss';

type Props = {
  scheduleTime: string;
};

export const ScheduleTimeCell = ({ scheduleTime }: Props) => {
  return <td className={styles.textCenter}>{scheduleTime}</td>;
};
